import React from 'react';
import ListK2 from '../../components/spravochniki/k2/ListK2'

function Page(props) {
    return (
        <>
          <ListK2 />
        </>
    );
}

export default Page;